import { SET_USER, SET_TOKEN, RESET } from "../constants";

export const setUser = (payload) => ({ type: SET_USER, payload });

export const setToken = (payload) => ({ type: SET_TOKEN, payload });

export const reset = (payload) => ({ type: RESET, payload });
